import Markdown from 'react-markdown'
import styled from 'styled-components'

export const MarkdownWrapper = styled(Markdown)`
  display: inline;
  p {
    display: inline;
  }
`
